// import React, { useState } from "react";
// import DefaultLayout from "../../../layout/vendor/DefaultLayout";
// import {
//   IoFilterSharp,
//   IoArrowForwardSharp,
//   IoArrowBackSharp,
// } from "react-icons/io5";
// import { FiDownload, FiEdit2 } from "react-icons/fi";
// import { FaPlus, FaArrowRight, FaRegTrashAlt } from "react-icons/fa";
// import { MdEdit } from "react-icons/md";
// import {
//   Table,
//   Button,
//   Container,
//   Row,
//   Col,
//   Pagination,
//   Image,
//   Badge,
//   Card,
//   Modal,
// } from "react-bootstrap";
// import { useNavigate, Link, useLocation } from "react-router-dom";
// import { useMutation, useQuery, useQueryClient } from "react-query";
// import api from "../../../utils/helper";
// import Footer from "../../../components/Footer";
// import { useAlerts } from "../../../context/AlertContext";
// import { useAuth } from "../../../context/AuthContext";
// import Delete from "../../../components/Delete";
// import { useIDsContext } from "../../../context/IDsContext";
// import { URLS } from "../../../utils/URL";

// const TeacherList = () => {
//   const courses = [
//     {
//       title: "Some course title",
//       optedOn: "28/09/2024",
//       duration: "2 Hours",
//       progress: 40,
//       status: "In Progress",
//     },
//     {
//       title: "Some course title",
//       optedOn: "28/09/2024",
//       duration: "2 Hours",
//       progress: 70,
//       status: "In Progress",
//     },
//     {
//       title: "Some course title",
//       optedOn: "28/09/2024",
//       duration: "2 Hours",
//       progress: 100,
//       status: "Completed",
//     },
//     {
//       title: "Some course title",
//       optedOn: "28/09/2024",
//       duration: "2 Hours",
//       progress: 10,
//       status: "In Progress",
//     },
//   ];
//   const [teacherToDelete, setTeacherToDelete] = useState(null);
//   const navigate = useNavigate();
//   const location = useLocation();
//   const { userID } = useAuth();
//   console.log(userID, "userID");
//   const { vendorId, collegeName } = location.state || {};
//   const { vendorID } = useIDsContext();
//   console.log("selectedVendor:", vendorID);
//   const { vendorName } = useIDsContext();
//   console.log("selectedvendorName:", vendorName);
//   const queryClient = useQueryClient();
//   const { showSuccess, showError } = useAlerts();
//   const [showDelete, setShowDelete] = useState();
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage] = useState(5); // Adjust as needed

//   console.log("Vendor Id:", vendorId, vendorName); // Use this to fetch filtered data
//   console.log("Vendor Id:", vendorId, vendorName); // Use this to fetch filtered data

//   const { data, isLoading, error } = useQuery(
//     ["teachers", userID, currentPage, itemsPerPage],
//     () =>
//       api.get(
//         `/super-admin/teachers/vendor/${userID}?page=${currentPage}&limit=${itemsPerPage}`
//       ),
//     {
//       enabled: !!userID,
//       onError: (err) => {
//         console.error(
//           "Error fetching teachers:",
//           err.response?.data?.message || err.message
//         );
//       },
//     }
//   );

//   const deleteMutation = useMutation(
//     (teacherID) => api.delete(`/super-admin/teachers/${teacherID}`),
//     {
//       onSuccess: (response) => {
//         showSuccess(response.data?.message || "Deleted successfully!");
//         console.log("Deleted successfully!", response);
//         queryClient.invalidateQueries("teachers");
//       },
//       onError: (error) => {
//         showError(error?.response?.data?.message || "Failed to deleted: ");
//         console.log("Failed to deleted: " + error.message);
//       },
//     }
//   );

//   const handleDelete = (id) => {
//     // Store the ID to be deleted
//     setTeacherToDelete(id);
//     setShowDelete(true);
//   };

//   // Ensure data.vendors exists and is an array
//   const teachers = data?.data?.data || [];
//   const totalPages = data?.data?.totalPages || 1;

//   const handleAddTeacher = () => {
//     navigate("/vendor/add-teacher", {
//       state: { userID, vendorName, isEdit: false },
//     });
//   };

//   const handlePageChange = (pageNumber) => {
//     if (pageNumber > 0 && pageNumber <= totalPages) {
//       setCurrentPage(pageNumber);
//     }
//   };

//   const [selectedTeacher, setSelectedTeacher] = useState([]);
//   const [showModal, setShowModal] = useState(false);

//   const handleRowClick = (teacher) => {
//     setSelectedTeacher(teacher || {});
//     setShowModal(true);
//   };
//   //const [currentPage, setCurrentPage] = useState(1);
//   // const itemsPerPage = 10; // Adjust as needed

//   return (
//     <DefaultLayout>
//       <div className="bgNav d-block d-lg-none pb-5 px-1 position-relative">
//         <div className="d-flex align-items-center justify-content-between mb-2">
//           <h2 className="heading mb-0 px-3">
//             <Link to="/vendor/teachers" className="linkHref">
//               <span>{vendorName}</span>
//             </Link>{" "}
//             <span className="heading text-light fw-bold">
//               {" "}
//               <FaArrowRight className="mx-1" /> Teachers
//             </span>
//           </h2>
//           <Badge pill className="header-badge mx-2">
//             {teachers.length} users
//           </Badge>
//         </div>
//         <div className="d-flex justify-content-between px-2 mt-3">
//           <Button variant="light" className="me-2 btn-sec">
//             <IoFilterSharp color="#344054" size={16} className="me-2" /> Filters
//           </Button>
//           <Button variant="light" className="me-2 btn-sec">
//             <FiDownload color="#344054" size={16} className="me-2" /> Export
//           </Button>
//           <Button
//             color="#60B1FF"
//             onClick={() => handleAddTeacher()}
//             className="btn-sec"
//           >
//             <FaPlus size={16} className="me-2" /> Add New
//           </Button>
//         </div>
//       </div>

//       <Container
//         fluid
//         className="main-container vendor-container mt-0 mt-md-4 ps-auto ps-md-0"
//       >
//         {/* Header Section */}
//         <Card className="main-card">
//           <Card.Header className="heading d-none d-lg-block">
//             <div className="d-flex justify-content-between align-items-center">
//               <div className="d-flex gap-2 align-items-center">
//                 <h2 className="text-muted venhead mb-0">
//                   <Link to="/vendor/teachers" className="linkHref">
//                     <span>{vendorName} </span>
//                   </Link>{" "}
//                   <span className="venhead fw-bold">
//                     {" "}
//                     <FaArrowRight /> Teachers
//                   </span>
//                 </h2>
//                 <Badge pill className="header-badge">
//                   {teachers.length} users
//                 </Badge>
//               </div>
//               <div>
//                 <Button variant="outline-secondary" className="me-2 btn-sec">
//                   <IoFilterSharp color="#344054" size={16} /> Filters
//                 </Button>
//                 <Button variant="outline-secondary" className="me-2 btn-sec">
//                   <FiDownload color="#344054" size={16} /> Export
//                 </Button>
//                 <Button
//                   color="#60B1FF"
//                   onClick={() => handleAddTeacher()}
//                   className="btn-sec"
//                 >
//                   <FaPlus size={16} /> Add New
//                 </Button>
//               </div>
//             </div>
//           </Card.Header>

//           <Table className="p-0 table-center" responsive>
//             <thead>
//               <tr>
//                 <th>
//                   <input
//                     type="checkbox"
//                     className="form-check-input"
//                     name="allSelect"
//                   />
//                 </th>
//                 <th>Teacher’s Name</th>
//                 <th>Enrolled On</th>
//                 <th>Status</th>
//                 <th>Courses Assigned</th>
//                 <th>Email Address</th>
//                 <th>College</th>
//                 <th> </th>
//               </tr>
//             </thead>
//             <tbody>
//               {error ? (
//                 <tr>
//                   <td colSpan="7" className="text-center">
//                     <div className="alert " role="alert">
//                       {error.response?.data?.message || "Something went wrong."}
//                     </div>
//                   </td>
//                 </tr>
//               ) : isLoading ? (
//                 <tr>
//                   <td colSpan="7" className="text-center">
//                     Loading...
//                   </td>
//                 </tr>
//               ) : teachers?.length === 0 ? (
//                 <tr>
//                   <td colSpan="7" className="text-center">
//                     No teacher found.
//                   </td>
//                 </tr>
//               ) : (
//                 teachers?.map((teacher) => (
//                   <tr key={teacher._id}>
//                     <td>
//                       <input
//                         type="checkbox"
//                         className="form-check-input"
//                         name="allSelect"
//                       />
//                     </td>

//                     <td
//                       onClick={() => handleRowClick(teacher)}
//                       style={{ cursor: "pointer" }}
//                     >
//                       <div className="textlogo">
//                         <img
//                           src={
//                             teacher.profile_img
//                               ? URLS.IMG_URL + teacher.profile_img
//                               : "/images/Avatar_1.png"
//                           }
//                           // src={college.profile_img ? URLS.IMG_URL + college.profile_img : "/images/bajaj.png"}
//                           alt="Teacher Logo"
//                           className="img-fluid "
//                           style={{ width: "30px", marginRight: "10px" }}
//                         />
//                         <div>
//                           <p className="mb-0 college-name-table">
//                             {" "}
//                             {teacher.firstname} {teacher.lastname}
//                           </p>

//                           <p className="mb-0">{teacher.uid}</p>
//                         </div>
//                       </div>
//                     </td>
//                     <td>{new Date(teacher.createdAt).toLocaleDateString()}</td>
//                     <td>
//                       {/* <Badge
//                       bg={teacher.status === "Active" ? "success" : "danger"}
//                     >
//                       {teacher.status}
//                     </Badge> */}
//                       <img
//                         src={
//                           teacher.status === true
//                             ? "/images/_Badge base.png"
//                             : "/images/Badge.png"
//                         }
//                         alt="Teacher Logo"
//                         className="activity-status"
//                         // style={{ width: "78px", height: "24px" }}
//                       />
//                     </td>
//                     <td>
//                       {teacher.assignedCourses?.length
//                         ? teacher.assignedCourses.join(", ")
//                         : "N/A"}
//                     </td>
//                     <td>{teacher.email}</td>
//                     <td>
//                       <p className="mb-0  college-name-table">
//                         <Badge className="college-name-label">
//                           {teacher.college.name}
//                         </Badge>
//                       </p>
//                     </td>
//                     <td>
//                       <div className="d-flex gap-2">
//                         <FaRegTrashAlt
//                           color="#475467"
//                           onClick={() => handleDelete(teacher._id)}
//                         />
//                         <FiEdit2
//                           color="#475467"
//                           onClick={() =>
//                             navigate("/vendor/add-teacher", {
//                               state: {
//                                 vendorId: vendorId,
//                                 teacher: teacher,
//                                 isEdit: true,
//                               },
//                             })
//                           }
//                           style={{ cursor: "pointer" }}
//                         />
//                       </div>
//                     </td>
//                   </tr>
//                 ))
//               )}
//             </tbody>
//           </Table>

//           {/* <Pagination>
//             {pageNumbers.map((number) => (
//               <Pagination.Item
//                 key={number}
//                 active={number === currentPage}
//                 onClick={() => handlePageChange(number)}
//               >
//                 {number}
//               </Pagination.Item>
//             ))}
//           </Pagination> */}
//         </Card>
//       </Container>

//       {/* Modal */}
//       <Modal
//         show={showModal}
//         onHide={() => setShowModal(false)}
//         dialogClassName="modal-left"
//         className="stus teacherProfile"
//       >
//         <Modal.Header closeButton onClick={() => setShowModal(false)}>
//           <Modal.Title className="suggestedCourse">Teacher Profile</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Container className="p-0">
//             <Row className="studentDetails m-0">
//               <Col
//                 md={4}
//                 className="d-flex justify-content-center align-items-center flex-column profileTeacher"
//               >
//                 <Image
//                   src="/images/Avatar_6.png"
//                   roundedCircle
//                   style={{
//                     width: "100px",
//                     height: "100px",
//                     marginRight: "20px",
//                   }}
//                 />
//                 <h5 className="mt-3 profileName">
//                   {selectedTeacher?.firstname || "N/A"}
//                   {selectedTeacher?.lastname || "N/A"}
//                 </h5>
//                 <p className="text-muted profileRollNo">
//                   {selectedTeacher?.uid || "N/A"}
//                 </p>
//                 <img
//                   src={
//                     selectedTeacher.status === "Active"
//                       ? "/images/_Badge base.png"
//                       : selectedTeacher.status === "Inactive"
//                       ? "/images/Badge.png"
//                       : "/images/Badge (1).png"
//                   }
//                   alt="student Logo"
//                   className="activity-status"
//                 />
//               </Col>

//               <Col md={8} className="bgDetailes">
//                 <div className="d-flex justify-content-end btnEdit mt-3">
//                   <Button
//                     variant="outline-secondary"
//                     className="me-2 btnEditAlt"
//                   >
//                     <FiEdit2 color="#344054" /> <span>Edit</span>
//                   </Button>
//                   <Button variant="outline-danger" className="btnTrashAlt">
//                     <FaRegTrashAlt />
//                   </Button>
//                 </div>
//                 <Row>
//                   <Col md={6} className="py-0">
//                     <div className="">
//                       <p className="profileEmail mb-0 fw-500 font-14">Email:</p>
//                       <p className="profileVendor py-1">
//                         {selectedTeacher?.email || "N/A"}
//                       </p>
//                     </div>
//                     <div className="pt-4">
//                       <p className="profileEmail mb-0 fw-500 font-14">
//                         Vendor:
//                       </p>
//                       <p className="profileVendor  py-1">
//                         {vendorName || "N/A"}
//                       </p>
//                     </div>
//                   </Col>
//                   <Col md={6} className="py-0">
//                     <div className="">
//                       <p className="profileEmail mb-0 fw-500 font-14">Phone:</p>
//                       <p className="profileVendor  py-1">
//                         {selectedTeacher?.phone || "N/A"}
//                       </p>
//                     </div>
//                     <div className="pt-4">
//                       <p className="profileEmail mb-0 fw-500 font-14">
//                         College:
//                       </p>
//                       <p className="profileVendor  py-1">
//                         {selectedTeacher?.college?.name || "N/A"}
//                       </p>
//                     </div>
//                   </Col>
//                 </Row>
//               </Col>
//             </Row>

//             <Row className="mt-4 p-3">
//               <Col md={4}>
//                 <Card>
//                   <Card.Body>
//                     <p className="courseComplete">Courses Assigned</p>
//                     <h2 className="family-inter  fw-500">
//                       {selectedTeacher?.coursesAssigned || 0}
//                     </h2>
//                   </Card.Body>
//                 </Card>
//               </Col>
//               <Col md={4}>
//                 <Card>
//                   <Card.Body>
//                     <p className="courseComplete">Student Assigned</p>
//                     <h2 className="family-inter  fw-500">
//                       {selectedTeacher?.studentAssigned || 0}
//                     </h2>
//                   </Card.Body>
//                 </Card>
//               </Col>
//               <Col md={4}>
//                 <Card>
//                   <Card.Body>
//                     <p className="courseComplete">Average Activity Time</p>
//                     <h2 className="family-inter fw-500">
//                       {selectedTeacher?.averageActivityTime || "0 mins"}
//                     </h2>
//                   </Card.Body>
//                 </Card>
//               </Col>
//             </Row>

//             {/* <Row className="p-3"> */}
//             <Row className="mx-0">
//               <div className="d-flex justify-content-between align-items-center p-1 px-4">
//                 <h2 className="suggestedCourse">Assigned Courses</h2>
//                 {/* <Button
//                   variant="primary"
//                   className="btn-sec"
//                   onClick={handleAssign}
//                 >
//                   <FaPlus /> Assign New
//                 </Button> */}
//               </div>
//               {courses?.map((course, index) => (
//                 <Col md={6} key={index} className="p-2 px-4">
//                   <Card className="mb-3 course-cardes">
//                     <Card.Body className="p-0">
//                       <div className="imagetext">
//                         <Image
//                           src="/images/card_image.png"
//                           className="cardimagelogo p-2"
//                         />
//                         <div className="course-details p-2">
//                           <div className="d-flex justify-content-between">
//                             <h5 className="courseEngage">{course.title}</h5>
//                             <FaRegTrashAlt className="m-2" />
//                           </div>
//                           <p className="opted m-0">
//                             Opted on: {course.optedOn}
//                           </p>
//                           <p className="opted m-0">
//                             Duration: {course.duration}
//                           </p>
//                           <div className="p-0 d-flex">
//                             <Badge bg="#F9F5FF" className="label1">
//                               Label
//                             </Badge>
//                             <Badge bg="#EFF8FF" className="label2">
//                               Label
//                             </Badge>
//                             <Badge bg="#EEF4FF" className="label3">
//                               Label
//                             </Badge>
//                             <Badge bg="#F2F4F7" className="label4">
//                               +4
//                             </Badge>
//                           </div>
//                         </div>
//                       </div>
//                     </Card.Body>
//                   </Card>
//                 </Col>
//               ))}
//             </Row>
//             {/* </Row> */}
//           </Container>
//         </Modal.Body>
//       </Modal>

//       <div className="d-none d-lg-block">
//         <Footer />
//       </div>
//       <Delete
//         show={showDelete}
//         close={() => setShowDelete(false)}
//         handleDelete={() => {
//           deleteMutation.mutate(teacherToDelete);
//           setShowDelete(false);
//         }}
//         title="Delete Teacher"
//       />
//     </DefaultLayout>
//   );
// };

// export default TeacherList;

import React, { useState } from "react";
import DefaultLayout from "../../../layout/vendor/DefaultLayout";
import {
  IoFilterSharp,
  IoArrowForwardSharp,
  IoArrowBackSharp,
} from "react-icons/io5";
import { FiDownload, FiEdit2 } from "react-icons/fi";
import { FaPlus, FaArrowRight, FaRegTrashAlt } from "react-icons/fa";
import { MdEdit } from "react-icons/md";
import {
  Table,
  Button,
  Container,
  Row,
  Col,
  Pagination,
  Image,
  Badge,
  Card,
  Modal,
  Spinner,
  Dropdown,
} from "react-bootstrap";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { useMutation, useQuery, useQueryClient } from "react-query";
import api from "../../../utils/helper";
import Footer from "../../../components/Footer";
import { useAlerts } from "../../../context/AlertContext";
import { useAuth } from "../../../context/AuthContext";
import Delete from "../../../components/Delete";
import { useIDsContext } from "../../../context/IDsContext";
import TeacherProfileModal from "./components/TeacherProfileModal";
import { URLS } from "../../../utils/URL";

const TeacherList = () => {
  const courses = [
    {
      title: "Some course title",
      optedOn: "28/09/2024",
      duration: "2 Hours",
      progress: 40,
      status: "In Progress",
    },
    {
      title: "Some course title",
      optedOn: "28/09/2024",
      duration: "2 Hours",
      progress: 70,
      status: "In Progress",
    },
    {
      title: "Some course title",
      optedOn: "28/09/2024",
      duration: "2 Hours",
      progress: 100,
      status: "Completed",
    },
    {
      title: "Some course title",
      optedOn: "28/09/2024",
      duration: "2 Hours",
      progress: 10,
      status: "In Progress",
    },
  ];
  const [teacherToDelete, setTeacherToDelete] = useState(null);
  const [teacherNameToDelete, setTeacherNameToDelete] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const { userID } = useAuth();
  console.log(userID, "userID");
  const { vendorId, collegeName } = location.state || {};
  const { vendorID } = useIDsContext();
  console.log("selectedVendor:", vendorID);
  const { vendorName } = useIDsContext();
  console.log("selectedvendorName:", vendorName);
  const queryClient = useQueryClient();
  const { showSuccess, showError } = useAlerts();
  const [showDelete, setShowDelete] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10); // Adjust as needed

  const [statusFilter, setStatusFilter] = useState(null); // 'true', 'false', or null
  const [dateFilter, setDateFilter] = useState(null); // 'last_month', 'last_3_months', 'last_6_months', or null

  // Calculate active filters count instead of tracking a single active filter
  const getActiveFiltersCount = () => {
    let count = 0;
    if (statusFilter !== null) count++;
    if (dateFilter !== null) count++;
    return count;
  };

  console.log("Vendor Id:", vendorId, vendorName); // Use this to fetch filtered data
  console.log("Vendor Id:", vendorId, vendorName); // Use this to fetch filtered data

  const { data, isLoading, error } = useQuery(
    ["teachers", userID, currentPage, itemsPerPage, statusFilter, dateFilter],
    () => {
      let endpoint = `/super-admin/teachers/vendor/${userID}?page=${currentPage}&limit=${itemsPerPage}`;

      if (statusFilter !== null) {
        endpoint += `&status=${statusFilter}`;
      }

      if (dateFilter) {
        endpoint += `&dateRange=${dateFilter}`;
      }

      return api.get(endpoint);
    },
    {
      enabled: !!userID,
      onError: (err) => {
        console.error(
          "Error fetching teachers:",
          err.response?.data?.message || err.message
        );
      },
    }
  );

  console.log(data, isLoading, error, "response");

  const handleExport = () => {
    console.log("report execute");
    // Construct the URL with the existing search parameter if any
    const exportUrl = `/super-admin/teachers/vendor/${userID}?downloadCSV=true&csvFields=firstname,lastname,email${
      statusFilter ? `&status=${statusFilter}` : ""
    }`;

    // Call the API with the download flag
    api
      .get(exportUrl, { responseType: "blob" })
      .then((response) => {
        // Create a blob URL from the response data
        console.log(response.data.data, "csv");

        const url = window.URL.createObjectURL(new Blob([response.data]));

        // Create a temporary anchor element
        const link = document.createElement("a");
        link.href = url;

        // Set the file name (you can adjust this based on your API response)
        link.setAttribute("download", "teachers.csv");

        // Append to the document, click it, and then remove it
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Revoke the blob URL to free up memory
        window.URL.revokeObjectURL(url);

        showSuccess("Teachers list exported successfully!");
      })
      .catch((error) => {
        showError(
          error?.response?.data?.message || "Failed to export teachers"
        );
        console.error("Export error:", error);
      });
  };

  const deleteMutation = useMutation(
    (teacherID) => api.delete(`/super-admin/teachers/${teacherID}`),
    {
      onSuccess: (response) => {
        showSuccess(response.data?.message || "Deleted successfully!");
        console.log("Deleted successfully!", response);
        queryClient.invalidateQueries("teachers");
      },
      onError: (error) => {
        showError(error?.response?.data?.message || "Failed to deleted: ");
        console.log("Failed to deleted: " + error.message);
      },
    }
  );

  const handleDelete = (id, teacherName) => {
    // Store the ID to be deleted
    setTeacherToDelete(id);
    setTeacherNameToDelete(teacherName);
    setShowDelete(true);
  };

  // Ensure data.vendors exists and is an array
  const teachers = data?.data?.data || [];
  const totalRecords = data?.data?.totalRecords || 0;
  const totalPages = data?.data?.totalPages || 1;

  const handleStatusFilter = (status) => {
    setStatusFilter(status === "active" ? true : false);
  };

  const handleDateFilter = (dateRange) => {
    setDateFilter(dateRange);
  };

  const clearFilter = () => {
    setStatusFilter(null);
    setDateFilter(null);
    queryClient.invalidateQueries("teachers");
  };

  const handleAddTeacher = () => {
    navigate("/vendor/add-teacher", {
      state: { userID, vendorName, isEdit: false },
    });
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  const [selectedTeacher, setSelectedTeacher] = useState([]);
  const [selectedTeachers, setSelectedTeachers] = useState([]);
  const [showModal, setShowModal] = useState(false);

  const handleRowClick = (teacher) => {
    setSelectedTeacher(teacher || {});
    setShowModal(true);
  };
  //const [currentPage, setCurrentPage] = useState(1);
  // const itemsPerPage = 10; // Adjust as needed

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const allTeacherIds = teachers.map((t) => t._id);
      setSelectedTeachers(allTeacherIds);
    } else {
      setSelectedTeachers([]);
    }
  };

  const handleCheckboxChange = (e, id) => {
    if (e.target.checked) {
      setSelectedTeachers((prev) => [...prev, id]);
    } else {
      setSelectedTeachers((prev) => prev.filter((tid) => tid !== id));
    }
  };

  // Get the count of active filters
  const activeFiltersCount = getActiveFiltersCount();

  return (
    <DefaultLayout>
      <div className="bgNav d-block d-lg-none pb-5 px-1 position-relative">
        <div className="d-flex align-items-center justify-content-between mb-2">
          <h2 className="heading mb-0 px-3">
            {/* <Link to="/vendor/teachers" className="linkHref"> */}
            <span className="linkHref">{vendorName}</span>
            {/* </Link>{" "} */}
            <span className=" text-light fw-bold">
              {" "}
              <FaArrowRight className="mx-1" /> Teachers
            </span>
          </h2>
          <Badge pill className="header-badge mx-2">
            {totalRecords} users
          </Badge>
        </div>
        <div className="d-flex justify-content-between px-2 mt-3">
          {/* Mobile View Filter Dropdown */}
          <Dropdown className="me-2">
            <Dropdown.Toggle
              variant="light"
              id="dropdown-basic"
              className="me-2 btn-sec "
            >
              <IoFilterSharp color="#344054" className="me-2" /> Filters
              {activeFiltersCount > 0 && (
                <Badge pill bg="primary" className="ms-1">
                  {activeFiltersCount}
                </Badge>
              )}
            </Dropdown.Toggle>

            <Dropdown.Menu className="c-menu">
              <Dropdown.Header>Status</Dropdown.Header>
              <Dropdown.Item onClick={() => handleStatusFilter("active")}>
                Active
              </Dropdown.Item>
              <Dropdown.Item onClick={() => handleStatusFilter("inactive")}>
                Inactive
              </Dropdown.Item>

              <Dropdown.Divider />

              <Dropdown.Header>Date Range</Dropdown.Header>
              <Dropdown.Item onClick={() => handleDateFilter("last_month")}>
                Last Month
              </Dropdown.Item>
              <Dropdown.Item onClick={() => handleDateFilter("last_3_months")}>
                Last 3 Months
              </Dropdown.Item>
              <Dropdown.Item onClick={() => handleDateFilter("last_6_months")}>
                Last 6 Months
              </Dropdown.Item>

              {activeFiltersCount > 0 && (
                <>
                  <Dropdown.Divider />
                  <Dropdown.Item onClick={clearFilter}>
                    Clear Filters
                  </Dropdown.Item>
                </>
              )}
            </Dropdown.Menu>
          </Dropdown>

          <Button
            variant="light"
            className="me-2 btn-sec"
            onClick={handleExport}
          >
            <FiDownload color="#344054" className="me-2" /> Export
          </Button>
          <Button
            color="#60B1FF"
            onClick={() => handleAddTeacher()}
            className="btn-sec"
            style={{ border: "transparent" }}
          >
            <FaPlus className="me-2" /> Add New
          </Button>
        </div>
      </div>

      <Container
        fluid
        className="main-container vendor-container mt-0 mt-md-4 ps-auto ps-md-0"
      >
        {/* Header Section */}
        <Card className="form-card">
          <Card.Header className="heading d-none d-lg-block">
            <div className="d-flex justify-content-between align-items-center">
              <div className="d-flex gap-2 align-items-center">
                <h2 className="text-muted venhead mb-0">
                  {/* <Link to="/vendor/teachers" className="linkHref"> */}
                  <span className="linkHref">{vendorName} </span>
                  {/* </Link>{" "} */}
                  <span className="venhead fw-bold">
                    {" "}
                    <FaArrowRight /> Teachers
                  </span>
                </h2>
                <Badge pill className="header-badge">
                  {totalRecords} users
                </Badge>
              </div>
              <div>
                {/* Desktop View Filter Dropdown */}
                <Dropdown className="d-inline-block">
                  <Dropdown.Toggle
                    variant="outline-secondary"
                    id="dropdown-basic"
                    className="me-2 btn-sec"
                  >
                    <IoFilterSharp color="#344054" size={16} /> Filters
                    {activeFiltersCount > 0 && (
                      <Badge pill bg="primary" className="ms-1">
                        {activeFiltersCount}
                      </Badge>
                    )}
                  </Dropdown.Toggle>

                  <Dropdown.Menu className="c-menu">
                    <Dropdown.Header>Status</Dropdown.Header>
                    <Dropdown.Item onClick={() => handleStatusFilter("active")}>
                      Active
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => handleStatusFilter("inactive")}
                    >
                      Inactive
                    </Dropdown.Item>

                    <Dropdown.Divider />

                    <Dropdown.Header>Date Range</Dropdown.Header>
                    <Dropdown.Item
                      onClick={() => handleDateFilter("last_month")}
                    >
                      Last Month
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => handleDateFilter("last_3_months")}
                    >
                      Last 3 Months
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => handleDateFilter("last_6_months")}
                    >
                      Last 6 Months
                    </Dropdown.Item>

                    {activeFiltersCount > 0 && (
                      <>
                        <Dropdown.Divider />
                        <Dropdown.Item onClick={clearFilter}>
                          Clear Filters
                        </Dropdown.Item>
                      </>
                    )}
                  </Dropdown.Menu>
                </Dropdown>

                <Button
                  variant="outline-secondary"
                  className="me-2 btn-sec"
                  onClick={handleExport}
                >
                  <FiDownload color="#344054" size={16} /> Export
                </Button>
                <Button
                  color="#60B1FF"
                  onClick={() => handleAddTeacher()}
                  className="btn-sec"
                >
                  <FaPlus size={16} /> Add New
                </Button>
              </div>
            </div>
          </Card.Header>

          {isLoading ? (
            <div className="text-center">
              <Spinner size="md" />
            </div>
          ) : (
            <Table className="p-0 table-center" responsive>
              <thead>
                <tr>
                  <th>
                    <input
                      type="checkbox"
                      className="form-check-input"
                      name="allSelect"
                      checked={
                        selectedTeachers.length === teachers.length &&
                        teachers.length > 0
                      }
                      onChange={handleSelectAll}
                    />
                  </th>
                  <th>Teacher’s Name</th>
                  <th>Enrolled On</th>
                  <th>Status</th>
                  <th>Courses Assigned</th>
                  <th>Email Address</th>
                  <th>College</th>
                  <th> </th>
                </tr>
              </thead>
              <tbody>
                {error ? (
                  <tr>
                    <td colSpan="7" className="text-center">
                      <div className="alert " role="alert">
                        {error.response?.data?.message ||
                          "Something went wrong."}
                      </div>
                    </td>
                  </tr>
                ) : isLoading ? (
                  <tr>
                    <td colSpan="7" className="text-center">
                      Loading...
                    </td>
                  </tr>
                ) : teachers?.length === 0 ? (
                  <tr>
                    <td colSpan="7" className="text-center">
                      No teacher found.
                    </td>
                  </tr>
                ) : (
                  [...teachers]
                    .filter((teacher) => teacher.createdAt) // ✅ avoid undefined dates
                    .sort(
                      (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
                    ) // ✅ newest first
                    .map((teacher) => (
                      <tr key={teacher._id}>
                        <td>
                          <input
                            type="checkbox"
                            className="form-check-input"
                            name="allSelect"
                            checked={selectedTeachers.includes(teacher._id)}
                            onChange={(e) =>
                              handleCheckboxChange(e, teacher._id)
                            }
                          />
                        </td>

                        <td
                          onClick={() => handleRowClick(teacher)}
                          style={{ cursor: "pointer" }}
                        >
                          <div className="textlogo">
                            <img
                              src={
                                teacher.profile_img
                                  ? URLS.IMG_URL + teacher.profile_img
                                  : "/images/Avatar_1.png"
                              }
                              // src={college.profile_img ? URLS.IMG_URL + college.profile_img : "/images/bajaj.png"}
                              alt="Teacher Logo"
                              className="rounded-circle "
                              style={{
                                width: "30px",
                                marginRight: "10px",
                                height: "31px",
                              }}
                            />
                            <div>
                              <p className="mb-0 college-name-table">
                                {" "}
                                {teacher.firstname} {teacher.lastname}
                              </p>

                              <p className="mb-0">{teacher.uid}</p>
                            </div>
                          </div>
                        </td>
                        <td>
                          {new Date(teacher.createdAt).toLocaleDateString()}
                        </td>
                        <td>
                          {/* <Badge
                      bg={teacher.status === "Active" ? "success" : "danger"}
                    >
                      {teacher.status}
                    </Badge> */}
                          <img
                            src={
                              teacher.status === true
                                ? "/images/_Badge base.png"
                                : "/images/Badge.png"
                            }
                            alt="Teacher Logo"
                            className="activity-status"
                            // style={{ width: "78px", height: "24px" }}
                          />
                        </td>
                        <td>{teacher.assignedCourses?.length || "N/A"}</td>
                        <td>{teacher.email}</td>
                        <td>
                          <p className="mb-0  college-name-table">
                            <Badge className="college-name-label">
                              {teacher.college.name}
                            </Badge>
                          </p>
                        </td>
                        <td>
                          <div className="d-flex gap-2">
                            <FaRegTrashAlt
                              color="#475467"
                              onClick={() =>
                                handleDelete(teacher._id, teacher.firstname)
                              }
                            />
                            <FiEdit2
                              color="#475467"
                              onClick={() =>
                                navigate("/vendor/add-teacher", {
                                  state: {
                                    vendorId: vendorId,
                                    teacher: teacher,
                                    isEdit: true,
                                  },
                                })
                              }
                              style={{ cursor: "pointer" }}
                            />
                          </div>
                        </td>
                      </tr>
                    ))
                )}
              </tbody>
            </Table>
          )}

          {totalPages > 1 && (
            <Pagination className="d-flex justify-content-between align-items-center p-2">
              <Button
                variant="outline-dark fw-bold"
                className="me-2"
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              >
                <IoArrowBackSharp size={20} /> Previous
              </Button>
              <div className="d-flex">
                {Array.from({ length: totalPages }).map((_, idx) => (
                  <Pagination.Item
                    className="mx-2"
                    key={idx + 1}
                    active={idx + 1 === currentPage}
                    onClick={() => handlePageChange(idx + 1)}
                  >
                    {idx + 1}
                  </Pagination.Item>
                ))}
              </div>
              <Button
                variant="outline-dark fw-bold pagination-prev-button"
                className="me-2"
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
              >
                Next <IoArrowForwardSharp size={20} />
              </Button>
            </Pagination>
          )}
        </Card>

        {/* Modals */}
        {selectedTeacher && (
          <TeacherProfileModal
            show={showModal}
            onHide={() => setShowModal(false)}
            teacher={selectedTeacher}
          />
        )}
      </Container>

      <div className="d-none d-lg-block">
        <Footer />
      </div>
      <Delete
        show={showDelete}
        close={() => setShowDelete(false)}
        handleDelete={() => {
          deleteMutation.mutate(teacherToDelete);
          setShowDelete(false);
        }}
        title="Delete Teacher"
        name={teacherNameToDelete}
      />
    </DefaultLayout>
  );
};

export default TeacherList;
